import { TailwindColors } from '@makyoapp/makyo-ui'

export const themesMap = {
  light: {
    bgCell: '#ffffff',
    textDark: '#000000',
    accentColor: TailwindColors?.teal?.[300],
    accentFg: TailwindColors?.teal?.[100],
    textGroupHeader: '#000000',
    textHeaderSelected: TailwindColors?.teal?.[900],
    borderColor: '#e5e7eb',
    cellHover: TailwindColors?.teal?.[100],
    bgSearchResult: '#F5F3E5',
  },
  dark: {
    bgCell: '#1f2937',
    textDark: '#ffffff',
    accentColor: TailwindColors?.teal?.[600],
    accentFg: TailwindColors?.teal?.[300],
    textGroupHeader: '#ffffff',
    textHeaderSelected: TailwindColors?.teal?.[100],
    bgHeader: '#111827',
    bgHeaderHovered: '#1f2937',
    bgHeaderHasFocus: '#1f2937',
    textHeader: '#ffffff',
    borderColor: '#374151',
    cellHover: TailwindColors?.slate?.[600],
    linkColor: TailwindColors?.sky?.[400],
    bgSearchResult: '#42402D',
  },
}
